import React from 'react'

export default function WebsiteLogo({ className = ''}) {
    return (
        <>
            <img
                //  LOGO IMAGE IS STATIC NOW 
                src={`/img/logo.png`}
              
                className={`show-logo max-w-[140px] m-auto ${className}`}
            />
        </>
    )
}
